import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { consentGateRoute, needsConsent } from './postLoginRoute'

/**
 * Guard del ORDEN consentimiento → cuestionario (doc 32 §4). Envuelve
 * `/data/:code`: si el jugador todavía no firmó el consentimiento, lo manda
 * al gate (`/consent`, ver `pages/ConsentGate.tsx`) con el cuestionario
 * colgado en `?next=`, así vuelve solo apenas acepta. Es el ÚNICO gate de
 * consentimiento que queda en el web-app: el camino de juego firma el suyo
 * adentro del vr-app (mg 2026-09-07).
 *
 * `postLoginRoute` ya antepone el gate en el login y en `/invite/:token`,
 * pero eso no alcanza para los caminos que entran a `/data/:code` sin pasar
 * por el SPA: el redirect del OAuth de Google (lo resuelve el backend con el
 * `next` crudo) y cualquier link directo o bookmark. Acá el orden se cierra
 * en la ruta misma.
 *
 * NO se monta en `/tablet/data/:code` (modo tablet): ese flujo tiene su propio
 * paso de consentimiento antes del cuestionario, dentro de `KitLayout`.
 *
 * El staff de club está eximido (ver `needsConsent`).
 */
export function RequireConsent({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  const location = useLocation()

  if (user && needsConsent(user)) {
    return (
      <Navigate
        to={consentGateRoute(`${location.pathname}${location.search}`)}
        replace
      />
    )
  }
  return <>{children}</>
}
